var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.taskList,"columns":_vm.tableColumns}}),_c('div',{staticClass:"paging_style"},[_c('Page',{attrs:{"size":"small","total":_vm.total,"page-size":_vm.query.pageSize,"show-total":"","show-elevator":"","current":_vm.query.pageNumber},on:{"on-change":_vm.handlePageNumberChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }